import { GridContainer } from 'libs/ui';
import { Benefit } from 'grids/benefit/benefit';

export const BenefitsWrapper = (props) => {
  return (
    <GridContainer>
      <Benefit {...props} />
    </GridContainer>
  );
};
